module.exports = __webpack_public_path__ + "static/a3-bf38714818d55d9fdd017b467c0c13bf.png";